import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReviewQueueItem from './Item'

class ReviewQueueList extends Component {
  render() {
    var quests = this.props.quests.map(function (quest, index) {
      return (
        <ReviewQueueItem
          quest={quest}
          key={index}
          user={this.props.user}
          dispatch={this.props.dispatch}
        />
      )
    }, this)

    return (
      <div className="review-queue-list">
        <ul>{quests}</ul>
      </div>
    )
  }
}

ReviewQueueList.propTypes = {
  quests: PropTypes.array,
  user: PropTypes.object,
  dispatch: PropTypes.func
}

export default ReviewQueueList



// WEBPACK FOOTER //
// ./src/components/reviewqueue/List.js